import type { CreateOrderSchema } from "@/api/schemas/order.schema";
import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import type { SaleWithRelations } from "@/types/sale-with-relations";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type CreateOrderInput = Pick<CreateOrderSchema, "items" | "userId">;

export function useCreateOrder() {
  const queryClient = useQueryClient();
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async (data: CreateOrderInput) => {
      const res = await http.post<SaleWithRelations>("/orders", data);
      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sale", "me"] });
    },

    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
